module.exports = __webpack_public_path__ + "static/media/photo145.f590488d.jpg";